import { createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("span", { class: "mx-right-arrow" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "mx-right-arrow" }, null, -1)
const _hoisted_3 = { class: "text" }
const _hoisted_4 = {
  key: 0,
  class: "mx-right-arrow"
}
const _hoisted_5 = {
  key: 0,
  class: "mx-context-menu-item-sperator"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContextSubMenu = _resolveComponent("ContextSubMenu", true)!

  return (_ctx.items)
    ? (_openBlock(), _createBlock("div", {
        key: 0,
        class: 'mx-context-menu ' + (_ctx.options.customClass ? _ctx.options.customClass : '') + (_ctx.menuReady ? ' ready' : ''),
        style: {
      maxWidth: _ctx.parentItem && _ctx.parentItem.maxWidth ? `${_ctx.parentItem.maxWidth}px` : `${_ctx.constOptions.defaultMaxWidth}px`,
      minWidth: _ctx.parentItem && _ctx.parentItem.minWidth  ? `${_ctx.parentItem.minWidth}px` : `${_ctx.constOptions.defaultMinWidth}px`,
      zIndex: _ctx.zIndex,
      left: `${_ctx.position.x}px`,
      top: `${_ctx.position.y}px`,
    },
        onMouseenter: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onMenuMouseEnter && _ctx.onMenuMouseEnter(...args))),
        onMouseleave: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onMenuMouseLeave($event)))
      }, [
        _withDirectives(_createVNode("div", {
          class: "mx-context-menu-updown up",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onScroll(false)))
        }, [
          _hoisted_1
        ], 512), [
          [_vShow, _ctx.menuOverflow]
        ]),
        _withDirectives(_createVNode("div", {
          class: "mx-context-menu-updown down",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onScroll(true)))
        }, [
          _hoisted_2
        ], 512), [
          [_vShow, _ctx.menuOverflow]
        ]),
        _createVNode("div", {
          class: "mx-context-menu-items",
          ref: "menu",
          style: {
        maxHeight: _ctx.maxHeight > 0 ? `${_ctx.maxHeight}px` : '',
      }
        }, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.items, (item, i) => {
            return (_openBlock(), _createBlock("div", { key: i }, [
              _createVNode("div", {
                class: 'mx-context-menu-item' + (item.disabled ? ' disabled' : ''),
                onMouseenter: ($event: any) => (_ctx.showChildItem($event, item)),
                onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.hideChildItem())),
                onFocus: ($event: any) => (_ctx.showChildItem($event, item)),
                onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.hideChildItem())),
                onClick: ($event: any) => (_ctx.onMouseClick(item))
              }, [
                _createVNode("span", _hoisted_3, [
                  _createVNode("i", {
                    class: item.icon + ' icon '+ _ctx.options.iconFontClass
                  }, null, 2),
                  _createVNode("span", null, _toDisplayString(item.label), 1),
                  (item.children && item.children.length > 0)
                    ? (_openBlock(), _createBlock("span", _hoisted_4))
                    : _createCommentVNode("", true)
                ])
              ], 42, ["onMouseenter", "onFocus", "onClick"]),
              (item.divided)
                ? (_openBlock(), _createBlock("div", _hoisted_5))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ], 4),
        (_ctx.activeItem && _ctx.activeItem.children)
          ? (_openBlock(), _createBlock(_component_ContextSubMenu, {
              key: 0,
              ref: "childMenu",
              zIndex: _ctx.zIndex+1,
              items: _ctx.activeItem.children,
              parentItem: _ctx.activeItem,
              options: _ctx.options,
              globalData: _ctx.childGlobalData,
              position: _ctx.childPosition,
              onClose: _ctx.onChildrenClose,
              onKeepOpen: _ctx.onChildrenKeepOpen,
              onPreUpdatePos: _ctx.onChildrenUpdatePos
            }, null, 8, ["zIndex", "items", "parentItem", "options", "globalData", "position", "onClose", "onKeepOpen", "onPreUpdatePos"]))
          : _createCommentVNode("", true)
      ], 38))
    : _createCommentVNode("", true)
}